import { ActionService } from 'dashboard-services/services';
import TimeService from 'dashboard-services/services/TimeService';
import { globalActions } from 'primary-components';

import { commonDatalakeActions } from 'actions/modules/datalake';
import basicInsightActions from 'actions/modules/insight/basic';
import { routing } from 'routing';

export default (() => {
  const DEFAULT_COLUMNS = ["Close", "Index", "Mid", "Last", "Value", "Volume", "Price", "Settlement"]
  
  const availableDefaultComponents = [
    { value: routing.dataLake.name, label: routing.dataLake.readableName },
    { value: routing.dataScience.name, label: routing.dataScience.readableName },
    { value: routing.dataStorage.name, label: routing.dataStorage.readableName },
    { value: routing.insight.name, label: routing.insight.readableName }
  ]

  const SET_SETTINGS = 'SET_USER_SETTINGS_MY_ACCOUNT'
  const setSettings = ActionService.makeActionCreator(SET_SETTINGS, 'settings')

  const CHANGE_SETTING = 'CHANGE_USER_SETTING_MY_ACCOUNT'
  const changeSettingChannel = new BroadcastChannel(CHANGE_SETTING)
  const changeSetting = (value, name) => dispatch => {
    changeSettingChannel.postMessage({
      type: CHANGE_SETTING,
      value,
      name
    })
    dispatch(changeSettingReducer(value, name))
  }
  const changeSettingReducer = ActionService.makeActionCreator(CHANGE_SETTING, 'value', 'name')

  const REMOVE_SETTING = 'REMOVE_USER_SETTING_MY_ACCOUNT'
  const removeSetting = name => dispatch => {
    changeSettingChannel.postMessage({ type: REMOVE_SETTING, name })
    dispatch(removeSettingReducer(name))
  }
  const removeSettingReducer = ActionService.makeActionCreator(REMOVE_SETTING, 'name')

  const onSettingChanged = () => dispatch => {
    changeSettingChannel.onmessage = e => {
      if(e.data.type === CHANGE_SETTING) {
        dispatch(changeSettingReducer(e.data.value, e.data.name))
      } else if(e.data.type === REMOVE_SETTING) {
        dispatch(removeSettingReducer(e.data.name))
      }
    }
  }

  const PUBLISH_COLUMNS = 'PUBLISH_COLUMNS_MY_ACCOUNT'
  const publishColumns = ActionService.makeActionCreator(PUBLISH_COLUMNS, 'columns')

  const PUBLISH_DISPLAY = 'PUBLISH_DISPLAY_MY_ACCOUNT'
  const publishDisplay = ActionService.makeActionCreator(PUBLISH_DISPLAY, 'symbolsDisplay', 'storageGroupsHidden', 'downloadFormat')

  const parseJSON = (value, defaultValue, displayName) => dispatch => {
    let localValue = defaultValue
    if(value) {
      try {
        localValue = JSON.parse(value)
      } catch {
        dispatch(globalActions.getMessageStore()).error(`${displayName} is not a proper JSON.`)
      }
    }
    return localValue
  }

  const getDashboardUserTabs = dashboardUserTabs => dispatch => (dispatch(parseJSON(dashboardUserTabs, [], "Dashboard user tabs")).map(tab => {
    if(typeof tab?.tag === "string") {
      return Object.assign({}, tab, { tag: [tab?.tag] })
    }
    return tab
  }))

  const getDefaultSettings = (settings = {}) => {
    const predefinedValues = {
        defaultPage: routing.insight.name, 
        definedTime: TimeService.UTC,
        storageGroupsHidden: false,
        dashboardUserTabs: "[]",
        darkmode: DARK_MODE.OFF,
        storageScreen: routing.dataStorage.routing.creator.hashes.table,
        datalakeLayout: commonDatalakeActions.DATALAKE_LAYOUT.VERSIONS,
        warehouse: WAREHOUSE.OFF,
        recents: "[]",
        recentTasks: "[]",
        colorPalettes: "[]",
        formulaPanelConstants: "[]",
        formulaPanelRecents: "[]",
        insightListView: basicInsightActions.ACTIVE_VIEWS.LIST,
        approvalsListView: commonDatalakeActions.APPROVALS_LIST_VIEW.VERSIONS
    }

    return ({
      ...predefinedValues,
      ...settings,
      additionalParameters: settings.additionalParameters === "true" || settings.additionalParameters === true ? true : false,
      defaultGroup: settings.defaultGroup || settings.userName + "_home",
      defaultPage: !availableDefaultComponents.find(a => a.value === settings.defaultPage) ? routing.insight.name : settings.defaultPage
    })
  }

  const saveSettings = ({ updateSettingsCall }) => (dispatch, getState) => {
    const settingsState = getState().myAccountState.settingsState
    return updateSettingsCall({
      settings: {
        darkmode: settingsState.darkmode || DARK_MODE.OFF,
        defaultGroup: settingsState.defaultGroup || `${settingsState.userName}_home`,
        defaultPage: settingsState.defaultPage || routing.insight.name,
        definedTime: TimeService.TIME_ZONES.find(s => s?.value === settingsState.definedTime)?.value || TimeService.UTC,
        roundingEnabled: String(settingsState.roundingEnabled === undefined ? false : settingsState.roundingEnabled),
        decimalPrecision: String(settingsState.decimalPrecision || 2),
        additionalParameters: settingsState.additionalParameters,
        storageScreen: settingsState.storageScreen,
        datalakeLayout: settingsState.datalakeLayout,
        warehouse: settingsState.warehouse || WAREHOUSE.OFF,
        recents: settingsState.recents || "[]",
        recentTasks: settingsState.recentTasks || "[]",
        colorPalettes: settingsState.colorPalettes || "[]",
        formulaPanelConstants: settingsState.formulaPanelConstants || "[]",
        formulaPanelRecents: settingsState.formulaPanelRecents || "[]",
        insightListView: settingsState.insightListView,
        approvalsListView: settingsState.approvalsListView
      }
    })
    .then(() => dispatch(globalActions.getMessageStore()).success("Settings have been saved."))
  }

  const DARK_MODE = {
    ON: "ON",
    OFF: "OFF",
    AUTO: "AUTO"
  }

  const WAREHOUSE = {
    ON: "ON",
    OFF: "OFF",
  }
  
  const RECENT_TYPES = {
    GROUP: "GROUP",
    PIPELINE: "PIPELINE",
    DATA_PREP: "DATA_PREP",
    INSIGHT: "INSIGHT",
    FORMULA: "FORMULA"
  }

  const RECENT_SIZE = 5

  const getRecents = () => (_, getState) => getState().myAccountState.settingsState.recents.slice()

  // TODO use just one method for recents
  const addRecent = ({ name, groupName, type, updateSettingsCall }) => dispatch => {
    const currentRecents = dispatch(getRecents()),
          recentsWithType = currentRecents.filter(cR => cR.type === type),
          existIndex = recentsWithType.findIndex(t => t.name === name && t.groupName === groupName && t.type === type)

    if(existIndex > -1) {
      recentsWithType.splice(existIndex, 1);
    } else if(recentsWithType.length === RECENT_SIZE) {
      recentsWithType.pop()
    }
    recentsWithType.unshift({ name, groupName, type })
    const newRecents = currentRecents.filter(cR => cR.type !== type).concat(recentsWithType)
    dispatch(changeSetting(newRecents, 'recents'))
    updateSettingsCall({ settings: { recents: JSON.stringify(newRecents) } })
    return newRecents;
  }

  // they are seperate, as they have fully different structre
  const getRecentTasks = () => (_, getState) => getState().myAccountState.settingsState.recentTasks.slice()

  const addRecentTask = ({ task, updateSettingsCall }) => dispatch => {
    const currentTasks = dispatch(getRecentTasks()),
          existIndex = currentTasks.findIndex(t => t.name === task.name && t.category === task.category)

    if(existIndex > -1) {
      currentTasks.splice(existIndex, 1);
    } else if(currentTasks.length === RECENT_SIZE) {
      currentTasks.pop()
    }
    currentTasks.unshift(task)
    dispatch(changeSetting(currentTasks, 'recentTasks'))
    updateSettingsCall({ settings: { recentTasks: JSON.stringify(currentTasks) } })
    return currentTasks;
  }

  const getRecentFormulaPanelItems = () => (_, getState) => getState().myAccountState.settingsState.formulaPanelRecents.slice()

  const addRecentFormulaPanelItem = ({ recentItem, updateSettingsCall }) => dispatch => {
    const currentItems = dispatch(getRecentFormulaPanelItems()),
          existIndex = currentItems.findIndex(i => i.type === recentItem.type && i.name === recentItem.name)

    if(existIndex > -1) {
      currentItems.splice(existIndex, 1);
    } else if(currentItems.length === RECENT_SIZE) {
      currentItems.pop()
    }
    currentItems.unshift(recentItem)
    dispatch(changeSetting(currentItems, 'formulaPanelRecents'))
    updateSettingsCall({ settings: { formulaPanelRecents: JSON.stringify(currentItems) } })
    return currentItems;
  }

  return {
    getDefaultSettings,
    saveSettings,
    SET_SETTINGS,
    PUBLISH_COLUMNS,
    publishColumns,
    PUBLISH_DISPLAY,
    publishDisplay,
    CHANGE_SETTING,
    changeSetting,
    REMOVE_SETTING,
    removeSetting,
    availableDefaultComponents,
    onSettingChanged,
    setSettings,
    DARK_MODE,
    WAREHOUSE,
    DEFAULT_COLUMNS,
    getDashboardUserTabs,
    addRecent,
    addRecentTask,
    RECENT_TYPES,
    addRecentFormulaPanelItem
  }
})()
